/** @jsxImportSource @emotion/react */

import { Column, Modal, Row, Typography } from "@a_team/ui-components";
import TrackButton from "components/TrackButton";
import { useRemoveMissionCollaborator } from "queries/missionSpecs/useRemoveMissionCollaborator";
import { useRootStore } from "store";

export const MissionCollaboratorRemoveModal = ({
  isOpen,
  missionId,
  name,
  onCancel,
  userId,
}: {
  isOpen: boolean;
  missionId?: string;
  name: string;
  onCancel: () => void;
  userId?: string;
}) => {
  const {
    uiStore: { setToast },
  } = useRootStore();

  const { mutateAsync: removeCollaborator, isLoading } =
    useRemoveMissionCollaborator();

  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      hideCloseButton={true}
      zIndex={10001}
    >
      <Typography variant="textLarge" component={"div"} weight="bold">
        {`Are you sure you want to remove ${name} from this team?`}
      </Typography>
      <Typography variant="textMedium" component={"p"}>
        If this collaborator is removed, they won’t be able to view this
        mission.
      </Typography>
      <Row>
        <Column></Column>
      </Row>
      <Row>
        <Column
          style={{ display: "flex", justifyContent: "flex-end", columnGap: 12 }}
        >
          <TrackButton
            name="Cancel removing mission collaborator"
            variant="secondary"
            onClick={onCancel}
          >
            Cancel
          </TrackButton>
          <TrackButton
            data-testing-id="remove-collaborator-button"
            disabled={isLoading}
            onClick={async () => {
              if (!userId || !missionId) {
                return;
              }
              await removeCollaborator({
                userId,
                missionId,
              });
              setToast({
                text: `${name} has been removed`,
                type: "success",
              });
              onCancel();
            }}
            name="Remove collaborator (mission)"
            variant="negative"
            loading={isLoading}
          >
            Remove
          </TrackButton>
        </Column>
      </Row>
    </Modal>
  );
};
